import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { GrupoDePrivilegioDTO, GrupoDePrivilegioResponseDTO } from '../../models/grupo-de-privilegio.model';

@Injectable({ providedIn: 'root' })
export class GrupoDePrivilegioService {
  constructor(private apiService: ApiService) {}

  get(url: string, data?: any): Observable<GrupoDePrivilegioResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<GrupoDePrivilegioResponseDTO>(path);
  }

  getById(url: string): Observable<GrupoDePrivilegioDTO> {
    return this.apiService.read<GrupoDePrivilegioDTO>(url);
  }

  post(url: string, data: GrupoDePrivilegioDTO): Observable<GrupoDePrivilegioDTO> {
    return this.apiService.create<GrupoDePrivilegioDTO>(url, data);
  }

  put(url: string, data: GrupoDePrivilegioDTO): Observable<GrupoDePrivilegioDTO> {
    return this.apiService.update<GrupoDePrivilegioDTO>(url, data);
  }

  delete(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  /** Busca com paginação por nome (ou id), conforme seu backend */
  searchByNome(nome: string, page = 0, size = 5) {
    // antes:
    // const qs = this.apiService.buildQueryParams({ nome, page, size });
    // return this.apiService.read<GrupoDePrivilegioResponseDTO>(`/grupoDePrivilegio/buscarPorNome?${qs}`);
  
    // depois (sem TS error):
    return this.get('/grupoDePrivilegio/buscarPorNome', { nome, page, size });
  }
}
